import { api_GET, api_POST, api_PUT, api_DELETE } from "./_api";

const relatorio_api = {

    DetalhadoPorTransportador: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/DetalhadoPorTransportador`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    DetalhadoPorGerador: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/DetalhadoPorGerador`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    GeradoresSemColeta: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/GeradoresSemColeta`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    ColetasDetalhado: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/ColetasDetalhado`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    DemonstrativoDeResumoDeOperacoes: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/DemonstrativoDeResumoDeOperacoes`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    DemonstrativoDeColetasPorGerador: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/DemonstrativoDeColetasPorGerador`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    ContratosPorTransportador: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/ContratosPorTransportador`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    EntradasAvulsas: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/EntradasAvulsas`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    MapaEstatistico: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/MapaEstatistico`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    GetCidadesIndicadores: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Relatorios/GetCidadesIndicadores`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    InscricaoMunicipaisGeradores: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/InscricaoMunicipaisGeradores`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    RedestinacaoDestinos: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/RedestinacaoDestinos`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    CertificadoBalancoMassa: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/CertificadoBalancoMassa`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    ResumoMovimentoMensal: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/ResumoMovimentoMensal`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    RelatorioTransportadores: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/RelatorioTransportadores`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    RelatorioDestinos: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/RelatorioDestinos`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    TransportadoresComContratosGeradores: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/TransportadoresComContratosGeradores`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    ColetasSintetica: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/ColetasSintetica`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    RelatorioGeradoresPontoColetas: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorios/RelatorioGeradoresPontoColetas`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
}
export default relatorio_api;